import { NOTIFICATION_TOOGLE, STATUS } from "../constant";

const initState = {
  notificationInfo: null,
  notificationInfoLoading: STATUS.LOADING
};

export default function notification(state = initState, action) {
  switch (action.type) {
    case NOTIFICATION_TOOGLE.NOTIFICATION_TOOGLE_START:
      return {
        ...state,
        notificationInfoLoading: STATUS.LOADING
      };

    case NOTIFICATION_TOOGLE.NOTIFICATION_TOOGLE_SUCCESS: {
      return {
        ...state,
        notificationInfo: action.payload.data,
        notificationInfoLoading: STATUS.SUCCESS
      };
    }

    case NOTIFICATION_TOOGLE.NOTIFICATION_TOOGLE_FAILURE:
      return {
        ...state,
        notificationInfo: null,
        notificationInfoLoading: null
      };

    case NOTIFICATION_TOOGLE.NONOTIFICATION_TOOGLE_UPDATE_STATUS:
      return {
        ...state,
        notificationInfo: null,
        notificationInfoLoading: null
      };

    default:
      return state;
  }
}
